import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataStudioRedesignRoutingModule } from './data-studio-redesign-routing.module';
import { DataStudioRedesignComponent } from './data-studio-redesign.component';
import { SharedModule } from 'app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DataFilesComponent } from './components/data-files/data-files.component';
import { DataFileSummaryComponent } from './components/data-file-summary/data-file-summary.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataAssetsComponent } from './components/data-assets/data-assets.component';
import { DataLiveDataComponent } from './components/data-live-data/data-live-data.component';
import { DataScadaComponent } from './components/data-scada/data-scada.component';
import { DataAnalysisComponent } from './components/data-analysis/data-analysis.component';
import { DataTurbineLogComponent } from './components/data-turbine-log/data-turbine-log.component';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { DataParkComponent } from './components/data-park-data/data-park.component';
import { DataMetadataComponent } from './components/data-metadata/data-metadata.component';
import { FeComponentLibraryModule } from '@wind-log_library/fe-component-library';
import { HighchartsChartModule } from 'highcharts-angular';
import { SignalsListComponent } from './components/data-analysis/time-series/signals-list/signals-list.component';
import { ElementSelectorComponent } from './components/data-analysis/time-series/element-selector/element-selector.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SignalsChartComponent } from './components/data-analysis/time-series/signals-chart/signals-chart.component';
import { NewSeriesComponent } from './components/data-analysis/time-series/new-series/new-series.component';
import { DataStudioPeriodComponent } from './components/data-studio-period/data-studio-period.component';
import { SeriesTableComponent } from './components/data-analysis/time-series/series-table/series-table.component';
import { MatSortModule } from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TimeSeriesComponent } from './components/data-analysis/time-series/time-series.component';
import { QueriesListComponent } from './components/data-analysis/time-series/queries-list/queries-list.component';
import { ScatterPlotComponent } from './components/data-analysis/scatter-plot/scatter-plot.component';
import { NewScatterPlotComponent } from './components/data-analysis/scatter-plot/new-scatter-plot/new-scatter-plot.component';
import { ScatterPlotSeriesListComponent } from './components/data-analysis/scatter-plot/signals-list/scatter-plot-series-list.component';
import { ScatterPlotSignalsChartComponent } from './components/data-analysis/scatter-plot/signals-chart/scatter-plot-signals-chart.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SignalsChartYAxisPopupComponent } from './components/data-analysis/time-series/signals-chart/signals-chart-y-axis-popup/signals-chart-y-axis-popup.component';
import { DataControlSystemItemsComponent } from './components/data-control-system-items/data-control-system-items.component';
import { ControlSystemSignalsComponent } from './components/control-system-signals/control-system-signals.component';
import { DataUnifiedItemsComponent } from './components/data-unified-items/data-unified-items.component';
import { MetmastsSignalsComponent } from './components/metmasts-signals/metmasts-signals.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { SignalsPreviewComponent } from './components/signals-preview/signals-preview.component';
import { TurbinesSignalsComponent } from './components/turbines-signals/turbines-signals.component';
import { DirectivesModule } from "app/shared/directives/directives.module";
import { PreviewChartComponent } from './components/signals-preview/preview-chart/preview-chart.component';

@NgModule({
  declarations: [
    DataStudioRedesignComponent,
    DataFilesComponent,
    DataFileSummaryComponent,
    DataLiveDataComponent,
    DataAssetsComponent,
    DataScadaComponent,
    DataTurbineLogComponent,
    DataParkComponent,
    DataMetadataComponent,
    DataAnalysisComponent,
    ElementSelectorComponent,
    SignalsListComponent,
    SignalsChartComponent,
    NewSeriesComponent,
    DataStudioPeriodComponent,
    SeriesTableComponent,
    TimeSeriesComponent,
    QueriesListComponent,
    ScatterPlotComponent,
    NewScatterPlotComponent,
    ScatterPlotSeriesListComponent,
    ScatterPlotSignalsChartComponent,
    SignalsChartYAxisPopupComponent,
    DataControlSystemItemsComponent,
    ControlSystemSignalsComponent,
    DataUnifiedItemsComponent,
    MetmastsSignalsComponent,
    SignalsPreviewComponent,
    TurbinesSignalsComponent,
    PreviewChartComponent
  ],
  imports: [
    CommonModule,
    DataStudioRedesignRoutingModule,
    SharedModule,
    TranslateModule,
    PipesModule,
    MatRadioModule,
    BsDatepickerModule.forRoot(),
    FormsModule,
    MatTooltipModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTabsModule,
    MatSelectModule,
    ReactiveFormsModule,
    FeComponentLibraryModule,
    HighchartsChartModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSlideToggleModule,
    ModalModule,
    MatExpansionModule,
    DirectivesModule
],
  exports: [
    SignalsChartComponent,
    ScatterPlotSignalsChartComponent
  ]
})
export class DataStudioRedesignModule { }
